<template>
  <div class="logout">
    <img
      :src="exitImg"
      alt="退出登录"
      class="logout-btn"
      @click="dialogVisible = true"
    >
    <van-overlay :show="dialogVisible">
      <div class="wrapper">
        <div class="content">
          <div class="logout-text">是否退出当前账号?</div>
          <div>
            <van-button
              type="primary"
              class="logout-cancel"
              round
              @click="dialogVisible = false"
            >取消</van-button
            >
            <span @click.once="logOut">
              <van-button
                type="primary"
                class="logout-sure"
                round
                color="linear-gradient(120deg, #000 0%, #000 97%)"
              >确定</van-button>
            </span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { removeToken } from '@/utils/auth'
import { logout } from '@/api/loginToC.js'
import { thirdAuthUrl } from '@/api/loginToB.js'

export default {
  name: 'Logout',
  data() {
    return {
      dialogVisible: false,
      exitImg: require('@/assets/images/logout.png')
    }
  },
  methods: {
    // 登出
    logOut() {
      const source = localStorage.getItem('source')
      if (this.$route.name === 'User') {
        // 车主用户，对奔驰来说应该是CIAM登录方式的用户
        logout().then(res => {
          removeToken()
          // 如果是从奔驰auth认证登录的本系统，则清除source标识，并且转到gas的登录地址
          // if (source === 'H5' || source === 'CIAM') {
          //   localStorage.removeItem('source')
          //   thirdAuthUrl({ target: source === 'CIAM' ? 'ciam' : 'auth', type: 'LOGOUT' }).then(url => { window.location = url })
          //   return
          // }
          // this.$router.go(0)
          localStorage.removeItem('source')
          console.log('LogOut.vue', 1)
          thirdAuthUrl({ target: source === 'CIAM' ? 'ciam' : 'auth', type: 'LOGOUT' }).then(url => { window.location = url })
        })
        return
      }
      // 非User路由下的登出操作，判定为企业/车企角色用户，如果调用logout会有鉴权失败错误，待调查为什么。
      removeToken()

      // 如果是从奔驰auth认证登录的本系统，则清除source标识，并且转到gas的登录地址
      // if (source === 'H5' || source === 'CIAM') {
      //   localStorage.removeItem('source')
      //   thirdAuthUrl({ target: source === 'CIAM' ? 'ciam' : 'auth', type: 'LOGOUT' }).then(url => { window.location = url })
      //   return
      // }
      // this.$router.go(0)
      localStorage.removeItem('source')
      console.log('LogOut.vue', 2)
      thirdAuthUrl({ target: source === 'CIAM' ? 'ciam' : 'auth', type: 'LOGOUT' }).then(url => { window.location = url })
    }
  }
}
</script>

<style lang="scss" scoped>
.logout {
  position: absolute;
  top: -70px;
  right: 0;
  z-index: 5;
  .logout-btn {
    width: 140px;
    height: 48px;
    margin-top: 82px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .content {
      width: 548px;
      height: 366px;
      background-image: linear-gradient(180deg, #ccddff 0%, #ffffff 36%);
      border-radius: 16px;
      padding: 0 36px;
      .logout-text {
        margin-top: 96px;
        margin-bottom: 88px;
        font-size: 36px;
        color: #212026;
        text-align: center;
        font-weight: 500;
      }
      .logout-cancel {
        width: 266px;
        height: 96px;
        line-height: 96px;
        font-size: 30px;
        background: linear-gradient(120deg, #fff 0%, #fff 97%);
        color: #242424;
        text-align: center;
        font-weight: 500;
        border: 1px solid;
      }
      .logout-sure {
        width: 266px;
        height: 96px;
        line-height: 96px;
        font-size: 32px;
        color: #ffffff;
        text-align: center;
        font-weight: 500;
      }
    }
  }
}
</style>
<style>
.nextStep{
  /* background: #000; */
  color: #fff;
  opacity:1;
  margin-top: 20px;
}
.lastStep{
  border: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/LogOut/index.vue